import { tokens } from '@fluentui/react-theme';
import { __styles, mergeClasses, shorthands } from '@griffel/react';
import { DURATION_2, DURATION_3, EASING_FUNCTION_1, EASING_FUNCTION_2, FADE_IN, SLIDE_DOWN_IN20, SLIDE_LEFT_IN20, SLIDE_RIGHT_IN20, SLIDE_UP_IN20 } from '../../utils/animations';
import { AnimationDirection } from '../Calendar/Calendar.types';
/**
 * @internal
 */
export const calendarPickerClassNames = {
  root: 'fui-CalendarPicker',
  headerContainer: 'fui-CalendarPicker__headerContainer',
  currentItemButton: 'fui-CalendarPicker__currentItemButton',
  navigationButtonsContainer: 'fui-CalendarPicker__navigationButtonsContainer',
  navigationButton: 'fui-CalendarPicker__navigationButton',
  gridContainer: 'fui-CalendarPicker__gridContainer',
  buttonRow: 'fui-CalendarPicker__buttonRow',
  itemButton: 'fui-CalendarPicker__itemButton',
  current: 'fui-CalendarPicker__current',
  selected: 'fui-CalendarPicker__selected',
  disabled: 'fui-CalendarPicker__disabled'
};
const useRootStyles = /*#__PURE__*/__styles({
  base: {
    B7ck84d: "f1e4lqlz",
    B68tc82: "f1p9o1ba",
    Bmxbyg5: "f1sil6mw",
    z8tnut: "f1kcqot9",
    z189sj: ["f11qrl6u", "fjlbh76"],
    Byoj8tv: "fpe6lb7",
    uwmqm3: ["fjlbh76", "f11qrl6u"],
    a9b677: "f4m2ahc"
  },
  normalize: {
    E5pizo: "f1couhl3",
    B7ck84d: "f1ewtqcl",
    B6of3ja: "f1hu3pq6",
    t21cq0: ["f11qmguv", "f1tyq0we"],
    jrapky: "f19f4twv",
    Frg6f3: ["f1tyq0we", "f11qmguv"],
    z8tnut: "f1g0x7ka",
    z189sj: ["fhxju0i", "f1cnd47f"],
    Byoj8tv: "f1qch9an",
    uwmqm3: ["f1cnd47f", "fhxju0i"]
  }
}, {
  d: [".f1e4lqlz{box-sizing:content-box;}", ".f1p9o1ba{overflow-x:hidden;}", ".f1sil6mw{overflow-y:hidden;}", ".f1kcqot9{padding-top:12px;}", ".f11qrl6u{padding-right:12px;}", ".fjlbh76{padding-left:12px;}", ".fpe6lb7{padding-bottom:12px;}", ".f4m2ahc{width:196px;}", ".f1couhl3{box-shadow:none;}", ".f1ewtqcl{box-sizing:border-box;}", ".f1hu3pq6{margin-top:0;}", ".f11qmguv{margin-right:0;}", ".f1tyq0we{margin-left:0;}", ".f19f4twv{margin-bottom:0;}", ".f1g0x7ka{padding-top:0;}", ".fhxju0i{padding-right:0;}", ".f1cnd47f{padding-left:0;}", ".f1qch9an{padding-bottom:0;}"]
});
const useHeaderContainerStyles = /*#__PURE__*/__styles({
  base: {
    mc9l5x: "f22iagw"
  }
}, {
  d: [".f22iagw{display:flex;}"]
});
const useCurrentItemButtonStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "f1c21dwh",
    icvyot: "f1ern45e",
    vrafjx: ["f1n71otn", "f1deefiw"],
    oivjwe: "f1h8hb77",
    wvpqe5: ["f1deefiw", "f1n71otn"],
    sj55zd: "f1ym3bx4",
    Bh6795r: "fqerorx",
    Bahqtrf: "f1mo0ibp",
    Be2twd7: "fkhj508",
    Bhrd7zp: "fl43uef",
    B68tc82: "f1mtd64y",
    Bmxbyg5: "f1y7q3j9",
    z8tnut: "f1g0x7ka",
    z189sj: ["f8wuabp", "fycuoez"],
    Byoj8tv: "f1qch9an",
    uwmqm3: ["frdkuqy", "f81rol6"],
    fsow6f: ["f1o700av", "fes3tcz"]
  },
  animation: {
    vin17d: "fhsqnsn",
    Bf5fcs: "fywypte",
    Bv12yb3: "f1h7u52p",
    Ezkn3b: "fjq4c94"
  },
  hasHeaderClickCallback: {
    Jwef8y: "f18a0fwf",
    Bi91k9c: "f3sdaeg",
    eoavqd: "f8491dx",
    Dwtyhm: "f14gx60i",
    ukgb2i: "f1o3croz",
    pugfm4: "f11jyo21",
    iro3zm: "f1wvkgvo",
    B2d53fq: "f1wdoaqd",
    c3iz72: "f13c0t7h",
    syojd9: "f190yoes",
    Bx68yb: "f98srbw",
    mghro0: "fw9cbop"
  }
}, {
  d: [".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".f1ern45e{border-top-style:none;}", ".f1n71otn{border-right-style:none;}", ".f1deefiw{border-left-style:none;}", ".f1h8hb77{border-bottom-style:none;}", ".f1ym3bx4{color:inherit;}", ".fqerorx{flex-grow:1;}", ".f1mo0ibp{font-family:inherit;}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".f1mtd64y{overflow-x:visible;}", ".f1y7q3j9{overflow-y:visible;}", ".f1g0x7ka{padding-top:0;}", ".f8wuabp{padding-right:4px;}", ".fycuoez{padding-left:4px;}", ".f1qch9an{padding-bottom:0;}", ".frdkuqy{padding-left:10px;}", ".f81rol6{padding-right:10px;}", ".f1o700av{text-align:left;}", ".fes3tcz{text-align:right;}", ".fhsqnsn{animation-duration:0.267s;}", ".fywypte{animation-fill-mode:both;}", ".f1h7u52p{animation-name:f5j8bii;}", ".fjq4c94{animation-timing-function:cubic-bezier(.1,.25,.75,.9);}"],
  k: ["@keyframes f5j8bii{from{opacity:0;}to{opacity:1;}}"],
  h: [".f18a0fwf:hover{background-color:var(--colorBrandBackgroundInvertedHover);}", ".f3sdaeg:hover{color:var(--colorBrandForegroundOnLightHover);}", ".f8491dx:hover{cursor:pointer;}", ".f14gx60i:hover{outline-width:1px;}", ".f1o3croz:hover{outline-style:solid;}", ".f11jyo21:hover{outline-color:var(--colorTransparentStroke);}", ".f1wvkgvo:hover:active{background-color:var(--colorBrandBackgroundInvertedPressed);}", ".f1wdoaqd:hover:active{color:var(--colorBrandForegroundOnLightPressed);}", ".f13c0t7h:hover:active{cursor:pointer;}", ".f190yoes:hover:active{outline-width:1px;}", ".f98srbw:hover:active{outline-style:solid;}", ".fw9cbop:hover:active{outline-color:var(--colorTransparentStroke);}"]
});
const useNavigationButtonsContainerStyles = /*#__PURE__*/__styles({
  base: {
    Bt984gj: "f122n59",
    mc9l5x: "f22iagw"
  }
}, {
  d: [".f122n59{align-items:center;}", ".f22iagw{display:flex;}"]
});
const useNavigationButtonStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "f1c21dwh",
    icvyot: "f1ern45e",
    vrafjx: ["f1n71otn", "f1deefiw"],
    oivjwe: "f1h8hb77",
    wvpqe5: ["f1deefiw", "f1n71otn"],
    Bbmb7ep: ["f2i1086", "f1rlsnju"],
    Beyfa6y: ["f1rlsnju", "f2i1086"],
    B7oj6ja: ["f1stktl2", "f1127022"],
    Btl43ni: ["f1127022", "f1stktl2"],
    sj55zd: "f19n0e5",
    mc9l5x: "ftgm304",
    Bahqtrf: "f1mo0ibp",
    Be2twd7: "fy9rknc",
    Bqenvij: "fxldao9",
    Bg96gwp: "f336tjw",
    sshi5w: "f1ysfysz",
    Bf4jedk: "f107v6xj",
    B68tc82: "f1mtd64y",
    Bmxbyg5: "f1y7q3j9",
    z8tnut: "f1g0x7ka",
    z189sj: ["fhxju0i", "f1cnd47f"],
    Byoj8tv: "f1qch9an",
    uwmqm3: ["f1cnd47f", "fhxju0i"],
    qhf8xq: "f10pi13n",
    fsow6f: "f17mccla",
    a9b677: "f1w9dchk",
    Jwef8y: "f18a0fwf",
    Bi91k9c: "f3sdaeg",
    eoavqd: "f8491dx",
    Dwtyhm: "f14gx60i",
    ukgb2i: "f1o3croz",
    pugfm4: "f11jyo21",
    iro3zm: "f1wvkgvo",
    B2d53fq: "f1wdoaqd"
  }
}, {
  d: [".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".f1ern45e{border-top-style:none;}", ".f1n71otn{border-right-style:none;}", ".f1deefiw{border-left-style:none;}", ".f1h8hb77{border-bottom-style:none;}", ".f2i1086{border-bottom-right-radius:2px;}", ".f1rlsnju{border-bottom-left-radius:2px;}", ".f1stktl2{border-top-right-radius:2px;}", ".f1127022{border-top-left-radius:2px;}", ".f19n0e5{color:var(--colorNeutralForeground1);}", ".ftgm304{display:block;}", ".f1mo0ibp{font-family:inherit;}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".fxldao9{height:28px;}", ".f336tjw{line-height:28px;}", ".f1ysfysz{min-height:28px;}", ".f107v6xj{min-width:28px;}", ".f1mtd64y{overflow-x:visible;}", ".f1y7q3j9{overflow-y:visible;}", ".f1g0x7ka{padding-top:0;}", ".fhxju0i{padding-right:0;}", ".f1cnd47f{padding-left:0;}", ".f1qch9an{padding-bottom:0;}", ".f10pi13n{position:relative;}", ".f17mccla{text-align:center;}", ".f1w9dchk{width:28px;}"],
  h: [".f18a0fwf:hover{background-color:var(--colorBrandBackgroundInvertedHover);}", ".f3sdaeg:hover{color:var(--colorBrandForegroundOnLightHover);}", ".f8491dx:hover{cursor:pointer;}", ".f14gx60i:hover{outline-width:1px;}", ".f1o3croz:hover{outline-style:solid;}", ".f11jyo21:hover{outline-color:var(--colorTransparentStroke);}", ".f1wvkgvo:hover:active{background-color:var(--colorBrandBackgroundInvertedPressed);}", ".f1wdoaqd:hover:active{color:var(--colorBrandForegroundOnLightPressed);}"]
});
const useGridContainerStyles = /*#__PURE__*/__styles({
  base: {
    B6of3ja: "fvjh0tl"
  }
}, {
  d: [".fvjh0tl{margin-top:4px;}"]
});
const useButtonRowStyles = /*#__PURE__*/__styles({
  base: {
    jrapky: "f15tpi3i",
    sw9gdo: "f1gdbdba"
  },
  animation: {
    vin17d: "f5f2jbu",
    Bf5fcs: "fywypte",
    Ezkn3b: "f1ee2ue"
  },
  horizontalBackward: {
    Bv12yb3: ["f1o9w3l8", "f1kwjajc"]
  },
  horizontalForward: {
    Bv12yb3: ["f1kwjajc", "f1o9w3l8"]
  },
  verticalBackward: {
    Bv12yb3: "fgl3yn7"
  },
  verticalForward: {
    Bv12yb3: "faiu5ye"
  }
}, {
  d: [".f15tpi3i{margin-bottom:16px;}", ".f1gdbdba:last-of-type{margin-bottom:0;}", ".f5f2jbu{animation-duration:0.367s;}", ".fywypte{animation-fill-mode:both;}", ".f1ee2ue{animation-timing-function:cubic-bezier(.1,.9,.2,1);}", ".f1o9w3l8{animation-name:f5j8bii,f2lgmc3;}", ".f1kwjajc{animation-name:f5j8bii,fpktcv7;}", ".fgl3yn7{animation-name:f5j8bii,f3bv9km;}", ".faiu5ye{animation-name:f5j8bii,funtx0y;}"],
  k: ["@keyframes f5j8bii{from{opacity:0;}to{opacity:1;}}", "@keyframes f2lgmc3{from{pointer-events:none;transform:translate3d(-20px, 0, 0);}to{pointer-events:auto;transform:translate3d(0, 0, 0);}}", "@keyframes fpktcv7{from{pointer-events:none;transform:translate3d(20px, 0, 0);}to{pointer-events:auto;transform:translate3d(0, 0, 0);}}", "@keyframes f3bv9km{from{pointer-events:none;transform:translate3d(0, -20px, 0);}to{pointer-events:auto;transform:translate3d(0, 0, 0);}}", "@keyframes funtx0y{from{pointer-events:none;transform:translate3d(0, 20px, 0);}to{pointer-events:auto;transform:translate3d(0, 0, 0);}}"]
});
const useItemButtonStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "f1c21dwh",
    icvyot: "f1ern45e",
    vrafjx: ["f1n71otn", "f1deefiw"],
    oivjwe: "f1h8hb77",
    wvpqe5: ["f1deefiw", "f1n71otn"],
    Bbmb7ep: ["f2i1086", "f1rlsnju"],
    Beyfa6y: ["f1rlsnju", "f2i1086"],
    B7oj6ja: ["f1stktl2", "f1127022"],
    Btl43ni: ["f1127022", "f1stktl2"],
    sj55zd: "f11d4kpn",
    Bahqtrf: "f1mo0ibp",
    Be2twd7: "fy9rknc",
    Bqenvij: "fbhnoac",
    Bg96gwp: "fc76cdq",
    sshi5w: "f1w5jphr",
    Bf4jedk: "f12clzc2",
    B6of3ja: "f1hu3pq6",
    t21cq0: ["f1x4n1mu", "f1hf5xhj"],
    jrapky: "f19f4twv",
    Frg6f3: ["f1tyq0we", "f11qmguv"],
    B68tc82: "f1mtd64y",
    Bmxbyg5: "f1y7q3j9",
    z8tnut: "f1g0x7ka",
    z189sj: ["fhxju0i", "f1cnd47f"],
    Byoj8tv: "f1qch9an",
    uwmqm3: ["f1cnd47f", "fhxju0i"],
    a9b677: "feqmc2u",
    Btgfwho: ["f65zstl", "f1yt3tqw"],
    xrote9: "flfbxit",
    Bja5ulm: "ff5vbxt",
    Jwef8y: "f18a0fwf",
    Bi91k9c: "f1u69ym5",
    eoavqd: "f8491dx",
    Dwtyhm: "f14gx60i",
    ukgb2i: "f1o3croz",
    pugfm4: "f11jyo21",
    Bqrx1nm: "f9ep5xw",
    ze5xyy: "f1qvjex",
    iyr2r2: "fd2qbv0",
    Bv57zgv: "fwr96hb",
    Bnosqey: "f7lk14",
    Bx7pl5v: "f143n69s",
    iro3zm: "f1wvkgvo",
    g2kj27: "f1b9qfq3",
    pc6evw: "f9ddjv3",
    B76w7ga: "fr4cgi0"
  }
}, {
  d: [".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".f1ern45e{border-top-style:none;}", ".f1n71otn{border-right-style:none;}", ".f1deefiw{border-left-style:none;}", ".f1h8hb77{border-bottom-style:none;}", ".f2i1086{border-bottom-right-radius:2px;}", ".f1rlsnju{border-bottom-left-radius:2px;}", ".f1stktl2{border-top-right-radius:2px;}", ".f1127022{border-top-left-radius:2px;}", ".f11d4kpn{color:var(--colorNeutralForeground3);}", ".f1mo0ibp{font-family:inherit;}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".fbhnoac{height:40px;}", ".fc76cdq{line-height:40px;}", ".f1w5jphr{min-height:40px;}", ".f12clzc2{min-width:40px;}", ".f1hu3pq6{margin-top:0;}", ".f1x4n1mu{margin-right:12px;}", ".f1hf5xhj{margin-left:12px;}", ".f19f4twv{margin-bottom:0;}", ".f1tyq0we{margin-left:0;}", ".f11qmguv{margin-right:0;}", ".f1mtd64y{overflow-x:visible;}", ".f1y7q3j9{overflow-y:visible;}", ".f1g0x7ka{padding-top:0;}", ".fhxju0i{padding-right:0;}", ".f1cnd47f{padding-left:0;}", ".f1qch9an{padding-bottom:0;}", ".feqmc2u{width:40px;}", ".f65zstl:nth-child(4n + 4){margin-right:0;}", ".f1yt3tqw:nth-child(4n + 4){margin-left:0;}", ".flfbxit:nth-child(n + 9){margin-bottom:0;}", ".ff5vbxt div{font-weight:var(--fontWeightRegular);}"],
  h: [".f18a0fwf:hover{background-color:var(--colorBrandBackgroundInvertedHover);}", ".f1u69ym5:hover{color:var(--colorNeutralForeground1Static);}", ".f8491dx:hover{cursor:pointer;}", ".f14gx60i:hover{outline-width:1px;}", ".f1o3croz:hover{outline-style:solid;}", ".f11jyo21:hover{outline-color:var(--colorTransparentStroke);}", ".f1wvkgvo:hover:active{background-color:var(--colorBrandBackgroundInvertedPressed);}"],
  m: [["@media (forced-colors: active){.f9ep5xw:hover{background-color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1qvjex:hover{color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fd2qbv0:hover{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fwr96hb:hover{outline-width:1px;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f7lk14:hover{outline-style:solid;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f143n69s:hover{outline-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1b9qfq3:hover:active{background-color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f9ddjv3:hover:active{color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fr4cgi0:hover:active{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }]]
});
const useCurrentStyles = /*#__PURE__*/__styles({
  highlightCurrent: {
    De3pzq: "ffp7eso",
    sj55zd: "f1phragk",
    Bhrd7zp: "fl43uef",
    Bsw6fvg: "fg374yq",
    Bbusuzp: "f1yig07e",
    ycbfsm: "fkc42ay",
    mk428o: "ffic4m0",
    B1lrsqs: "f13lyc4l",
    z0vste: "f13g7o2i",
    Bgjd7nk: "fbbf6h8",
    kur00z: "f1fsg2me"
  }
}, {
  d: [".ffp7eso{background-color:var(--colorBrandBackground);}", ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}"],
  m: [["@media (forced-colors: active){.fg374yq{background-color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1yig07e{color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f13g7o2i:hover,.f13g7o2i:hover:active{background-color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fbbf6h8:hover,.fbbf6h8:hover:active{color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1fsg2me:hover,.f1fsg2me:hover:active{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }]],
  h: [".ffic4m0:hover,.ffic4m0:hover:active{background-color:var(--colorBrandBackground);}", ".f13lyc4l:hover,.f13lyc4l:hover:active{color:var(--colorNeutralForegroundOnBrand);}"]
});
const useSelectedStyles = /*#__PURE__*/__styles({
  highlightSelected: {
    De3pzq: "f1vevd59",
    sj55zd: "ff5vbop",
    Bhrd7zp: "fl43uef",
    Bsw6fvg: "f1rirnrt",
    Bbusuzp: "f1yig07e",
    ycbfsm: "fkc42ay",
    Bja5ulm: "fospawf",
    Jwef8y: "fbo057p",
    Bi91k9c: "f1u69ym5",
    Bqrx1nm: "fiu8gst",
    ze5xyy: "f1v4q6pl",
    iyr2r2: "fd2qbv0",
    iro3zm: "f1wvkgvo"
  }
}, {
  d: [".f1vevd59{background-color:var(--colorBrandBackgroundInvertedSelected);}", ".ff5vbop{color:var(--colorNeutralForeground1Static);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".fospawf div{font-weight:var(--fontWeightSemibold);}"],
  m: [["@media (forced-colors: active){.f1rirnrt{background-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1yig07e{color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fiu8gst:hover{background-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1v4q6pl:hover{color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fd2qbv0:hover{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }]],
  h: [".fbo057p:hover{background-color:var(--colorBrandBackgroundInvertedSelected);}", ".f1u69ym5:hover{color:var(--colorNeutralForeground1Static);}", ".f1wvkgvo:hover:active{background-color:var(--colorBrandBackgroundInvertedPressed);}"]
});
const useDisabledStyles = /*#__PURE__*/__styles({
  base: {
    Bg33ivm: "f1oelgmz",
    t69wg0: "fhh1ekj",
    Bbusuzp: "f1dcs8yz",
    ycbfsm: "fkc42ay"
  }
}, {
  d: [".f1oelgmz,.f1oelgmz:disabled,.f1oelgmz button{color:var(--colorNeutralForegroundDisabled);}", ".fhh1ekj,.fhh1ekj:disabled,.fhh1ekj button{pointer-events:none;}"],
  m: [["@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }]]
});
/**
 * @internal
 *
 * Apply styling to the CalendarPicker slots based on the state
 */
export const useCalendarPickerStyles_unstable = props => {
  const rootStyles = useRootStyles();
  const headerContainerStyles = useHeaderContainerStyles();
  const currentItemButtonStyles = useCurrentItemButtonStyles();
  const navigationButtonsContainerStyles = useNavigationButtonsContainerStyles();
  const navigationButtonStyles = useNavigationButtonStyles();
  const gridContainerStyles = useGridContainerStyles();
  const buttonRowStyles = useButtonRowStyles();
  const itemButtonStyles = useItemButtonStyles();
  const currentStyles = useCurrentStyles();
  const selectedStyles = useSelectedStyles();
  const disabledStyles = useDisabledStyles();
  const {
    animateBackwards,
    animationDirection,
    className,
    hasHeaderClickCallback,
    highlightCurrent,
    highlightSelected
  } = props;
  return {
    root: mergeClasses(calendarPickerClassNames.root, rootStyles.normalize, rootStyles.base, className),
    headerContainer: mergeClasses(calendarPickerClassNames.headerContainer, headerContainerStyles.base),
    currentItemButton: mergeClasses(calendarPickerClassNames.currentItemButton, currentItemButtonStyles.base, animateBackwards !== undefined && currentItemButtonStyles.animation, hasHeaderClickCallback && currentItemButtonStyles.hasHeaderClickCallback),
    navigationButtonsContainer: mergeClasses(calendarPickerClassNames.navigationButtonsContainer, navigationButtonsContainerStyles.base),
    navigationButton: mergeClasses(calendarPickerClassNames.navigationButton, navigationButtonStyles.base),
    gridContainer: mergeClasses(calendarPickerClassNames.gridContainer, gridContainerStyles.base),
    buttonRow: mergeClasses(calendarPickerClassNames.buttonRow, buttonRowStyles.base, buttonRowStyles.animation, animateBackwards !== undefined && (animationDirection === AnimationDirection.Horizontal ? animateBackwards ? buttonRowStyles.horizontalBackward : buttonRowStyles.horizontalForward : animateBackwards ? buttonRowStyles.verticalBackward : buttonRowStyles.verticalForward)),
    itemButton: mergeClasses(calendarPickerClassNames.itemButton, itemButtonStyles.base),
    selected: mergeClasses(calendarPickerClassNames.selected, highlightSelected && selectedStyles.highlightSelected),
    current: mergeClasses(calendarPickerClassNames.current, highlightCurrent && currentStyles.highlightCurrent),
    disabled: mergeClasses(calendarPickerClassNames.disabled, disabledStyles.base)
  };
};
//# sourceMappingURL=useCalendarPickerStyles.styles.js.map